import {useEffect} from "react";
import {updateSureTax} from "../../../misc/updateSureTax";


const useUpdateSureTax = (visualizersLoadedLength, cartItems, runUpdates = true, withLoader = true) => {

  useEffect(() => {
    if (runUpdates && (visualizersLoadedLength > 0) && cartItems.length) {
      updateSureTax(withLoader)
    }
  }, [visualizersLoadedLength, cartItems, runUpdates, withLoader])

  return null
};


export default useUpdateSureTax
